import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { billingCurrency, FOUNDER_RESERVATION_ENDS_AT, founderReservationOpen, founderTrialActive } from '@alexiarest/shared';
import { useMe } from '../api/hooks';

export function FounderTrialBanner(): JSX.Element | null {
  const tenant = useMe().data?.tenant;
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const timer = window.setInterval(() => setNow(Date.now()), 1000); return () => window.clearInterval(timer); }, []);
  if (!tenant?.founderPending || !tenant.founderTrial) return null;
  const deadline = tenant.founderReservationEndsAt ?? FOUNDER_RESERVATION_ENDS_AT;
  const open = founderReservationOpen(deadline, now);
  const active = founderTrialActive(tenant, now);
  const days = Math.max(0, Math.ceil((Date.parse(tenant.founderTrial.endsAt) - now) / 86400000));
  const currency = billingCurrency(tenant.country);
  const price = currency === 'EUR' ? '39 €' : '39 USD';
  const until = open ? new Intl.DateTimeFormat('es-ES', { timeZone: 'Europe/Madrid', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(Date.parse(deadline) - 60000)) : '';
  return <div className={`aviso-pago ${active ? '' : 'aviso-pago--bloqueo'}`}>
    <p className="aviso-pago__texto"><strong>{active ? `Tu prueba: ${days} ${days === 1 ? 'día restante' : 'días restantes'}.` : 'Tu prueba ha terminado. Tu cuenta está en modo lectura.'}</strong>{' '}
      {open ? `Tu precio Founder de ${price}/mes sigue reservado hasta el ${until} (hora de Madrid).` : 'La reserva Founder ha terminado. Puedes elegir Básico o Pro.'}
    </p>
    <Link className="btn btn--primary" to={open ? '/founder' : '/ajustes?tab=plan'}>{open ? 'Activar Founder' : 'Ver planes'}</Link>
  </div>;
}
